import { Component, OnInit, } from '@angular/core';
import { UserService } from '../services/user.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { EncriptDecriptService } from '../services/encriptdecript';

@Component({
  selector: 'app-login-akku',
  templateUrl: './login-akku.component.html',
  styleUrls: ['./login-akku.component.scss'],
})
export class LoginAkkuComponent implements OnInit {

  public userName: any;
  public userobject: any;
  userObj: any;
  loginData: any;
  constructor(private userService: UserService,
     private activateRoute: ActivatedRoute,
     private router: Router,private encriptDecript:EncriptDecriptService) { }

  ngOnInit() {
    this.activateRoute.queryParams.subscribe((params: Params) => {
      this.userName = params['userName'];
    })
    this.authenticateAkkuUser();
  }

  authenticateAkkuUser() {
    this.userService.loginAkku(this.userName).subscribe(response => {
       response.data;
       if (response.status.success !== 'Success' && response.status.success == 'Fail') {
        localStorage.setItem('errorMessage','User Not Found');
        this.router.navigate(['/login']);
      } 
      else if (response.data) {
        this.getUserDetailsByEmailId(response);
      }
    })
  }

  getUserDetailsByEmailId(response) {
    // const payLoad = {
    //   emailId: user.emailId,
    //   passwordHash: user.passwordHash
    // }
    // this.userService.login(payLoad).subscribe(response => {
      this.loginData = response;
      if (response.status.success !== 'Success' && response.status.success == 'Fail') {
        localStorage.setItem('errorMessage',response.status.message);
      } else {
        this.encriptDecript.setKyeToLocalStorage('token',response.token);
        // this.encriptDecriptService.getKeyLocalStorage('token')=response.token;
        localStorage.isLogin=true;
        this.encriptDecript.setToLocalStorage('userObject' , this.loginData.data);
        this.userObj = this.encriptDecript.getLocalStorage('userObject');
        const userDetail = JSON.parse(this.userObj);
        const role = userDetail.roles[0];
        localStorage.setItem('logo',null);
        if (this.loginData.data.isAdmin === true) {
         this.encriptDecript.setToLocalStorage('dashboardURL' , '/admin/dashboard');
          this.router.navigate(['/admin/dashboard']);
        } else {
          let routeNavigation: any;
          this.encriptDecript.setToLocalStorage('dashboardURL' , '/admin/dashboard');
          for (let i = 0; i < role.applicationRolePermission.length; i++) {
            if (role.applicationRolePermission[i].isUpdate ||
              role.applicationRolePermission[i].isWrite ||
              role.applicationRolePermission[i].isDelete) {
              return routeNavigation = this.router.navigate(['/admin/dashboard']);
            } else {
              this.encriptDecript.setToLocalStorage('userName' , this.loginData.data.firstName);
              this.encriptDecript.setToLocalStorage('email' , this.loginData.data.emailId); 
              this.encriptDecript.setToLocalStorage('dashboardURL' , '/user/dashboard/browse');
              routeNavigation = this.router.navigate(['/user/dashboard/browse']); }
          }
          return routeNavigation;
        }
      }
    // }, (error => {

    // }));
  }

}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/login-akku/login-akku.component.ts